import { render, staticRenderFns } from "./HomeTerms.vue?vue&type=template&id=0e8fc66c&scoped=true"
import script from "./HomeTerms.vue?vue&type=script&lang=js"
export * from "./HomeTerms.vue?vue&type=script&lang=js"
import style0 from "./HomeTerms.vue?vue&type=style&index=0&id=0e8fc66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8fc66c",
  null
  
)

export default component.exports